import React from "react";
import { DashboardOverviewComponent } from "../../features/dashboard/components/dashboard.component";

export const DashboardHomeComponent: React.FC = () => {
  return <DashboardOverviewComponent />;
};
